<template>
  <div style="width: 100%;height: 100%;">
    <div class="map-open" @click="opens">
      <img style="width: 40px" src="../../../assets/coordinate_left_up.png">
    </div>
    <div class="top-new">
      <div class="send-btn1" @click="getSendSite()"><span>刷新位置</span></div>
    </div>
    <div style="height: 100%">
      <iframe id="mainIframe"
              ref="mainIframe"
              name="mainIframe"
              :style="{width: '100%', height: '100%', margin: 'auto', zoom: 1 / this.golobleObject.zoom}"
              src="../../../../static/showLocation.html"
              frameborder="0"
              scrolling="no">
      </iframe>
    </div>
  </div>
</template>

<script>
import {sendcommand, querydeviceposition} from '../../../api/device'

export default {
  name: 'mapLocation',
  props: {
    handleMapObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      mapObj: {
        deviceRow: '',
        lat: '',
        lng: '',
        type: ''
      },
      num: 0,
      intervalId: null
    }
  },
  created () {
    this.mapObj = this.handleMapObj
    console.log(88, this.handleMapObj.deviceRow.person)
    this.golobleObject.childMapSend = this.getStartMarker // 地图加载完
    this.golobleObject.getSiteLocation = this.getSendSite
  },
  destroyed () {
    if (this.timerShow) {
      this.timeNum = 0
      clearInterval(this.timerShow)
      this.timerShow = null
    }
  },
  methods: {
    opens () {
      let lng = 0
      let lat = 0
      console.log(this.mapObj)
      if (this.mapObj.type === 'device') { // 设备管理
        lng = this.mapObj.lng
        lat = this.mapObj.lat
      } else {
        lng = this.mapObj.alarmRow.lng
        lat = this.mapObj.alarmRow.lat
      }
      let url = `https://ditu.amap.com/regeo?lng=${lng}&lat=${lat}`
      window.open(url)
    },
    getStartMarker () {
      console.log(999, this.mapObj)
      window.frames['mainIframe'].window.getParentAdd(this.mapObj)
    },
    // 设备管理 有 获取位置 按钮
    getSendSite () {
      // 定位模式 按次定位 发送指令
      let data = {
        imei: this.mapObj.deviceRow.deviceid,
        did: this.mapObj.deviceRow.id
      }
      // [300-, 350-, 351, 352, 353, 901-, 903-, 310-, 311-, 312-, 313-, 330-, 331-]
      if (this.mapObj.deviceRow.devicetype === 300 || this.mapObj.deviceRow.devicetype === 901 || this.mapObj.deviceRow.devicetype === 903) {
        data.method = 'requirelocation'
        data.command1 = '1'
        data.command2 = '2'
        data.command3 = '1'
        data.command4 = '2'
      } else {
        // 310 311 312 313 330 331 350 351 352 353
        data.method = 'requirelocation310'
        data.command1 = '1|1|1|5'
        data.reserved2 = this.mapObj.deviceRow.devicetype + ''
      }
      sendcommand(data).then(res => {
        this.$notify({ title: '成功', message: '指令发送成功', type: 'success' })
        this.getImeiData()
      }).catch(() => {})
    },
    getImeiData () {
      this.num = 0
      let vm = this
      vm.getLocationDevice()
      // console.log(this.num)
      this.intervalId = setInterval(() => {
        vm.getLocationDevice()
      }, 5000)
    },
    getLocationDevice () {
      console.log(this.num)
      this.num += 1
      let data = {
        did: this.mapObj.deviceRow.id,
        imei: this.mapObj.deviceRow.deviceid
      }
      if (this.num === 5) {
        this.$message.info('暂无位置更新')
        clearInterval(this.intervalId)
        this.intervalId = null
        this.num = 0
      }
      querydeviceposition(data).then(res => {
        let obj = res.data.deviceposition[0]
        if (parseFloat(this.mapObj.lng) !== parseFloat(obj.lng) || parseFloat(this.mapObj.lat) !== parseFloat(obj.lat)) {
          // this.$toast('成功刷新位置')
          console.log('成功刷新位置', obj, this.mapObj)
          this.$message.success('成功刷新位置')
          clearInterval(this.intervalId)
          this.intervalId = null
          this.num = 0
          this.mapObj.lng = parseFloat(obj.lng)
          this.mapObj.lat = parseFloat(obj.lat)
          this.mapObj.deviceRow.last_online = obj.ptime
          this.mapObj.deviceRow.battery = obj.battery
          this.getStartMarker()
        }
      }).catch(() => {
        this.$message.info('暂无位置更新')
        clearInterval(this.intervalId)
        this.intervalId = null
        this.num = 0
      })
    }
  }
}
</script>

<style scoped>
.map-open{
  cursor: pointer;
  position: absolute;
  top: 90px;
  left: 10px;
}
.top-new{
  cursor: pointer;
  position: absolute;
  top: 40px;
  right: 10px;
  height: 40px;
  width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/components/handlealarm/childComponents/mapLocation.vue